export const selectResumeLoading = (s) => s.scaResume?.scaResumeLoading === true;
export const selectResumeError = (s) => s.scaResume?.scaResumeError || null;
export const selectResumeCooldown = (s) => s.scaResume?.scaResumeCooldown || 0;

export const selectPendingRecipientChange = (s) =>
  !!(s.user && s.user.data && s.user.data.pending_recipient_change);

export const selectShouldShowResumeCTA = selectPendingRecipientChange; // alias for clarity
